module.exports = {
      id: "illustrations:AU03-usage",
      viewBox: "0 0 231 233",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#illustrations:AU03-usage",
      toString: function () {
        return this.url;
      }
    }